const adresses = [
  '1010',
  '1020',
  '1030',
  '1040',
  '1050',
  '1060',
  '1070',
  '1080',
  '1090',
  '1100',
  '1110',
  '1120',
  '1130',
  '1140',
  '1150',
  '1160',
  '1170',
  '1180',
  '1190',
  '1200',
  '1210',
  '1220',
  '1230',
  '1300',
  '2100',
  '2102',
  '2103',
  '2201',
  '2202',
  '2203',
  '2281',
  '2282',
  '2301',
  '2304',
  '2320',
  '2322',
  '2325',
  '2326',
  '2331',
  '2332',
  '2333',
  '2334',
  '2340',
  '2344',
  '2345',
  '2351',
  '2352',
  '2353',
  '2355',
  '2361',
  '2362',
  '2371',
  '2372',
  '2380',
  '2381',
  '2384',
  '2391',
  '2392',
  '2393',
  '2401',
  '2431',
  '2432',
  '2435',
  '2440',
  '2441',
  '2442',
  '2481',
  '2482',
  '2483',
  '2484',
  '2486',
  '2490',
  '2491',
  '2492',
  '2493',
  '2500',
  '2504',
  '2511',
  '2512',
  '2514',
  '2521',
  '2522',
  '2523',
  '2524',
  '2525',
  '2531',
  '2540',
  '2542',
  '2544',
  '2551',
  '2552',
  '2601',
  '2603',
  '2751',
  '3001',
  '3002',
  '3003',
  '3011',
  '3264',
  '3292',
  '3293',
  '3342',
  '3343',
  '3344',
  '3345',
  '3400',
  '3420',
  '3421',
  '3423',
];
export default adresses;
